import createDuck, { createAction, createThunk } from "../utils/actions";
import axios from "../net/axios";
import config from "../config";
let baseUrl = config.api.baseUrl;
const newActions = {
  test: (name) => createAction("NAME", name),
};

const newReducers = {
  NAME: (state, action) => {
    const nState = { data: action.payload, loading: false, error: null };
    return { ...state, ...nState };
  },
};

const duck = createDuck("ADD_CONTACTO", newActions, newReducers);

const addContactoThunk = (data) => {
  const url = `${baseUrl}/addContacto`;
  return createThunk(axios, "post", duck.actions, url, data);
};

const duckUpdateContacto = createDuck("UPDATE_CONTACTO", newActions, newReducers);

const updateContactoThunk = (data) => {
  const url = `${baseUrl}/updateContacto`;
  return createThunk(axios, "post", duckUpdateContacto.actions, url, data);
};

const duckContactoById = createDuck("GET_CONTACTO_BY_ID", newActions, newReducers);

const getContactoByIdThunk = (data) => {
  const url = `${baseUrl}/getContactoById`;
  return createThunk(axios, "post", duckContactoById.actions, url, data);
};



const duckGetContactos = createDuck("GET_CONTACTOS", newActions, newReducers);

const getContactosThunk = (
  localId,
  page,
  limit,
  nombre = null,
  documento = null
) => {
  let url =  `${baseUrl}/getContactos/${localId}?page=${page}&limit=${limit}`;

  if (nombre) {
    url = url + `&nombre=${nombre}`;
  }
  if (documento) {
    url = url + `&documento=${documento}`;
  }
  return createThunk(axios, "get", duckGetContactos.actions, url, null);
};

const duckAddAsistencia = createDuck("ADD_ASISTENCIA", newActions, newReducers);

const addAsistenciaThunk = (data) => {
  const url = `${baseUrl}/addAsistencia`;
  return createThunk(axios, "post", duckAddAsistencia.actions, url, data);
};

const duckReservaOptions = createDuck("RESERVA_OPTIONS", newActions, newReducers);

const getReservaOptionsThunk = (data) => {
  const url = `${baseUrl}/reservasByFechasForAsistencias`;
  return createThunk(axios, "post", duckReservaOptions.actions, url, data);
};

const duckContactoByDocument = createDuck("GET_CONTACTO_BY_DOCUMENT", newActions, newReducers);

const getContactoByDocumentThunk = (data) => {
  const url = `${baseUrl}/getContactoByDocument`;
  return createThunk(axios, "post", duckContactoByDocument.actions, url, data);
};

const duckGetAsistenciasByDategGroup = createDuck("GET_ASISTENCIAS_BY_GROUP", newActions, newReducers);

const getAsistenciasByGroupThunk = (
  localId,
  fecha = null,
  fechaFin = null,
) => {
  let url =  `${baseUrl}/getAsistenciasByDategGroup/${localId}`;

  if (fecha && fechaFin) {
    url = url + `?fecha=${fecha}&fechaFin=${fechaFin}`;
  }

  return createThunk(axios, "get", duckGetAsistenciasByDategGroup.actions, url, null);
};

const duckGetAsistenciasByDate = createDuck("GET_ASISTENCIAS_BY_DATE", newActions, newReducers);

const getAsistenciasByDateThunk = (
  localId,
  fecha,
  page,
  limit,

) => {
  let url =  `${baseUrl}/getAsistenciasByDate/${localId}/${fecha}?page=${page}&limit=${limit}`;


  return createThunk(axios, "get", duckGetAsistenciasByDate.actions, url, null);
};

const exp = {
  duck,
  addContactoThunk,
  duckUpdateContacto,
  updateContactoThunk,
  duckContactoById,
  getContactoByIdThunk,
  duckGetContactos,
  getContactosThunk,
  duckAddAsistencia,
  addAsistenciaThunk,
  duckReservaOptions,
  getReservaOptionsThunk,
  duckContactoByDocument,
  getContactoByDocumentThunk,
  duckGetAsistenciasByDategGroup,
  getAsistenciasByGroupThunk,
  duckGetAsistenciasByDate,
  getAsistenciasByDateThunk,
};

export default exp;
